"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShareButtonType = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var ShareButtonType;
exports.ShareButtonType = ShareButtonType;

(function (ShareButtonType) {
  ShareButtonType["TWITTER"] = "twitter";
  ShareButtonType["FACEBOOK"] = "facebook";
  ShareButtonType["LINKEDIN"] = "linkedin";
  ShareButtonType["WHATSAPP"] = "whatsapp";
})(ShareButtonType || (exports.ShareButtonType = ShareButtonType = {}));

var Share = function Share(_ref) {
  var buttons = _ref.buttons,
      renderAsButton = _ref.renderAsButton;
  return (0, _preact.h)("div", {
    className: "social-sharing"
  }, (0, _preact.h)(_Tooltip.default, {
    renderAsButton: renderAsButton,
    withArrow: true,
    trigger: (0, _preact.h)("div", {
      className: "share-button btn--secondary"
    }, (0, _preact.h)(_assets.default, {
      size: 20,
      icon: "share"
    })),
    tooltipMessage: (0, _preact.h)("div", {
      className: "share-container"
    }, buttons.map(function (button, index) {
      if (button.type === ShareButtonType.LINKEDIN) {
        return (0, _preact.h)("a", {
          title: button.linkTitle,
          className: (0, _classnames.default)('btn', 'btn--icon', 'btn--linkedin', 'qa-button-linkedin'),
          target: "_blank",
          rel: "noreferrer",
          key: "".concat(index, "_").concat(button.type),
          href: (0, _absoluteUrlRuntime.resolveUrl)("http://www.linkedin.com/shareArticle?mini=true&url=".concat(encodeURI(window.location.href), "&title=").concat(encodeURI(button.title), "&summary=").concat(encodeURI(button.content)))
        }, (0, _preact.h)(_phrase.default, {
          p: "linkedin.share"
        }));
      }

      if (button.type === ShareButtonType.FACEBOOK) {
        return (0, _preact.h)("a", {
          title: button.linkTitle,
          className: (0, _classnames.default)('btn', 'btn--icon', 'btn--facebook', 'qa-button-facebook'),
          target: "_blank",
          rel: "noreferrer",
          key: "".concat(index, "_").concat(button.type),
          href: (0, _absoluteUrlRuntime.resolveUrl)(facebookShareUrl({
            title: button.title
          }))
        }, (0, _preact.h)(_phrase.default, {
          p: "facebook.share"
        }));
      }

      if (button.type === ShareButtonType.TWITTER) {
        return (0, _preact.h)("a", {
          title: button.linkTitle,
          className: (0, _classnames.default)('btn', 'btn--icon', 'btn--x', 'qa-button-twitter'),
          target: "_blank",
          rel: "noreferrer",
          key: "".concat(index, "_").concat(button.type),
          href: (0, _absoluteUrlRuntime.resolveUrl)("http://twitter.com/intent/tweet?text=".concat(encodeURI(window.location.href)))
        }, (0, _preact.h)(_phrase.default, {
          p: "twitter.share"
        }));
      }

      if (button.type === ShareButtonType.WHATSAPP) {
        return (0, _preact.h)("a", {
          title: button.linkTitle,
          className: (0, _classnames.default)('btn', 'btn--icon', 'btn--whatsapp', 'icon', 'icon--whatsapp', 'is-hidden-mobile-up'),
          key: "".concat(index, "_").concat(button.type),
          href: (0, _absoluteUrlRuntime.resolveUrl)("whatsapp://send?text=".concat(encodeURI(window.location.href)))
        }, (0, _preact.h)(_phrase.default, {
          p: "whatsapp.share"
        }));
      }

      return null;
    }))
  }));
};

var facebookShareUrl = function facebookShareUrl(_ref2) {
  var title = _ref2.title,
      url = _ref2.url;
  var urlToShare = url !== null && url !== void 0 ? url : window.location.href;
  var appId = (0, _globals.default)('facebookAppId');

  if (appId !== '') {
    return "https://www.facebook.com/dialog/feed?app_id=".concat(encodeURI(appId.toString()), "&display=popup&caption=").concat(encodeURI(title), "&link=").concat(encodeURI(urlToShare));
  }

  return "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURI(urlToShare));
};

var _default = Share;
exports.default = _default;